// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import AjaxStateSwitcher from '../controls/AjaxStateSwitcher'
import AjaxDeleteButton from '../controls/AjaxDeleteButton'
import { translations, translateFunc } from '../../shared/localize'
import Menu from './Menu'
import BudgetPopup from './BudgetPopup'
import PaymentPopup from './PaymentPopup'
import StateHumanHint from '../AdvertisementsTable/StateHumanHint'
import StateSwitcher from '../controls/StateSwitcher'
import { Link, MenuItem, NameLink, BodyRow, Cell, Tooltip } from '../MainTable'
import styled, { type StyledComponent } from 'styled-components'
import { offColor } from '../controls/colors'
import Checkbox from '../controls/Checkbox'
import type { FbPlacements, ProviderEstimates } from '../types'
import TotalLimitPopup from './TotalLimitPopup'
import NamePopup from './NamePopup'
import type {
  ConsumerPlatformType,
  FbPlacementPlatformRenderData,
  FbPlacementPositionRenderData,
  FbPlacementRenderData
} from '../AudienceEdit/fbPlacements'
import { renderData } from '../AudienceEdit/fbPlacements'

const MenuLink: StyledComponent<Object, any, any> = styled.a`
  text-decoration: none;
`
const RejectedCounterWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline;
  position: relative;
  top: -7px;
`
const RejectedCounter: StyledComponent<Object, any, any> = styled(Link)`
  margin: 0 5px;
  background: ${({ isMuted }: Object) => (isMuted ? offColor : '#d32a2a')};
  color: white;
  border-radius: 2px;
  font-size: 9px;
  padding: 1px 3px;
  &:hover {
    opacity: 0.8;
    color: white !important;
  }
`
const MenuWraper: StyledComponent<Object, any, any> = styled.div`
  padding-left: 6px;
`
const StyledBodyRow: StyledComponent<Object, any, any> = styled(BodyRow)`
  .text {
    font-family: 'PT Sans Caption', sans-serif;
    font-size: 11px;
    color: #000;
  }
  a.text {
    border-bottom: 1px dashed #b2b2b2;
    &:hover {
      border-bottom-color: transparent;
    }
  }
`
const MainCellContent: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  align-items: center;
`
const NameWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-grow: 1;
  max-width: 250px;
  margin-left: -10px;
`
const SwitcherWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-right: 16px;
`
const NameWrapperElement: StyledComponent<Object, any, any> = styled.div`
  padding-left: 10px;
`

type Props = {|
  id: number,
  locale: string,
  activateUrl: string,
  deactivateUrl: string,
  name: string,
  archiveUrl: string,
  active: boolean,
  humanState: Object,
  stateValue: string,
  checked: boolean,
  onArchive: Function,
  copyPath: string,
  editPath: string,
  providers_list: Array<string>,
  advertisementsPath: string,
  rejectedAdsCount: number,
  newAdvertisementPath: string,
  onArchivationRollback?: Function,
  isLastInGroup?: boolean,

  budget: string,
  minMonthBudget: number,
  minDailyBudget: number,
  maxBudget: number,
  price: string,
  detailStatisticsPath: string,
  statistics: Object,
  estimates: ProviderEstimates,

  audience_type: string,
  placement_type: string,
  advertisementsCount: number,
  budget_cycle: string,
  payment_type: string,
  audienceCheckboxChecked: boolean,
  onAudienceCheckboxChange: Function,
  onAudienceStateChange: Function,
  selectedFields: Array<string>,
  platform: ConsumerPlatformType,
  fb_placements: FbPlacements,
  vk_placement: string,
  locations: Array<string>,
  sex: string,
  min_age: number | null,
  max_age: number | null,
  interests: Array<string>,
  demographics: Array<string>,
  total_limit: string,
  imported: boolean
|}

export default class AudienceTableRow extends Component<Props> {
  tableTranslations: Function
  attributeTranslations: Function

  constructor(props: Props) {
    super(props)

    const { locale } = props

    this.tableTranslations = translateFunc(translations.campaigns_table, { locale: locale })
    this.attributeTranslations = translateFunc(translations.audience_edit)
  }

  render() {
    const {
      id,
      budget,
      minMonthBudget,
      minDailyBudget,
      maxBudget,
      price,
      detailStatisticsPath,
      statistics,
      audienceCheckboxChecked,
      selectedFields
    } = this.props

    return (
      <StyledBodyRow
        bottomShadow={this.props.isLastInGroup}
        className={`t-AudienceRow${this.props.active ? '' : ' off'}`}
      >
        <Cell>
          <Checkbox
            className="t-AudienceRowCheckbox"
            onChange={(checked) => {
              this.props.onAudienceCheckboxChange(checked)
            }}
            checked={audienceCheckboxChecked}
          />
        </Cell>
        {this.renderMainCell()}
        <Cell>
          <div className="inline-block">
            <StateHumanHint
              triggerText={this.props.humanState.title}
              hintText={this.props.humanState.description}
              styleCode={this.statusStyle()}
            />
          </div>
        </Cell>
        {this.renderAdvertisementsCell()}
        {_.map(selectedFields, (field: string) => {
          switch (field) {
            case 'budget':
              return (
                <Cell alignRight className="nowrap" key={`audience_${id}_budget`}>
                  <BudgetPopup
                    budget={budget}
                    budgetCycle={this.props.budget_cycle}
                    minMonthBudget={minMonthBudget}
                    minDailyBudget={minDailyBudget}
                    maxBudget={maxBudget}
                    audienceId={id}
                    onAudienceStateChange={(data, id) =>
                      this.props.onAudienceStateChange(data, [id])
                    }
                  />
                </Cell>
              )
            case 'payment':
              return (
                <Cell alignRight className="nowrap" key={`audience_${id}_payment`}>
                  <PaymentPopup
                    audienceType={this.props.audience_type}
                    paymentType={this.props.payment_type}
                    price={price}
                    audienceId={id}
                    onAudienceStateChange={(data, id) =>
                      this.props.onAudienceStateChange(data, [id])
                    }
                  />
                </Cell>
              )
            case 'spent':
              return (
                <Cell alignRight className="t-StatLink offable" key={`audience_${id}_${field}`}>
                  <a href={detailStatisticsPath}>{statistics[field]}</a>
                </Cell>
              )
            case 'users':
              return this.renderUsersCell()
            case 'cpc_effective':
            case 'cpm_effective':
              return this.renderEstimatePriceCell(field)
            case 'placement_type':
              return this.renderCommonCell(field, this.props.placement_type)
            case 'sex':
              return this.renderCommonCell(field, this.props.sex)
            case 'platform':
              return this.renderCommonCell(field, this.props.platform)
            case 'vk_placement':
              return this.renderCommonCell(field, this.props.vk_placement)
            case 'fb_placements':
              return this.renderFbPlacementsCell()
            case 'providers_list':
              return (
                <Cell alignRight className="nowrap" key={`audience_${id}_providers_list`}>
                  {_.join(this.props.providers_list, ', ')}
                </Cell>
              )
            case 'locations':
              return this.renderLabelsCell(field, this.props.locations)
            case 'interests':
              return this.renderLabelsCell(field, this.props.interests)
            case 'demographics':
              return this.renderLabelsCell(field, this.props.demographics)
            case 'age':
              return this.renderAgeCell()
            case 'total_limit':
              return (
                <Cell alignRight className="nowrap" key={`audience_${id}_total_limit`}>
                  <TotalLimitPopup
                    totalLimit={this.props.total_limit}
                    audienceId={id}
                    onAudienceStateChange={(data, id) =>
                      this.props.onAudienceStateChange(data, [id])
                    }
                  />
                </Cell>
              )
            default:
              return (
                <Cell alignRight className="nowrap" key={`audience_${id}_${field}`}>
                  {statistics[field]}
                </Cell>
              )
          }
        })}
        <Cell alignRight>{this.renderMenu()}</Cell>
      </StyledBodyRow>
    )
  }

  statusStyle() {
    let state = this.props.stateValue

    if (!this.props.active) return 'off'
    if (_.includes(['paused', 'no_ads', 'rejected', 'no_external_active_ads'], state))
      return 'alert'
  }

  renderMenu() {
    const {
      copyPath,
      detailStatisticsPath,
      editPath,
      advertisementsPath,
      newAdvertisementPath,
      archiveUrl,
      onArchive,
      onArchivationRollback,
      imported
    } = this.props

    return (
      <MenuWraper>
        <Menu isMuted={!this.props.active} className="t-RowMenu">
          <MenuLink href={copyPath}>
            <MenuItem>{this.tableTranslations('copy')}</MenuItem>
          </MenuLink>
          <MenuLink href={detailStatisticsPath}>
            <MenuItem>{this.tableTranslations('statistics')}</MenuItem>
          </MenuLink>
          <MenuLink href={editPath}>
            <MenuItem>{this.tableTranslations('settings')}</MenuItem>
          </MenuLink>
          <MenuLink href={advertisementsPath}>
            <MenuItem>{this.tableTranslations('advertisements_list')}</MenuItem>
          </MenuLink>
          {!imported && (
            <MenuLink href={newAdvertisementPath}>
              <MenuItem>{this.tableTranslations('create_advertisement')}</MenuItem>
            </MenuLink>
          )}
          <MenuItem>
            <AjaxDeleteButton
              url={archiveUrl}
              requestParams={{ ids: [this.props.id] }}
              onStart={() => onArchive && onArchive()}
              onFail={() => onArchivationRollback && onArchivationRollback()}
            >
              {this.tableTranslations('archivate')}
            </AjaxDeleteButton>
          </MenuItem>
        </Menu>
      </MenuWraper>
    )
  }

  renderMainCell() {
    const { id, activateUrl, deactivateUrl, editPath, name } = this.props

    return (
      <Cell>
        <MainCellContent>
          <SwitcherWrapper>
            <AjaxStateSwitcher
              isCompact
              switcherComponent={StateSwitcher}
              checked={this.props.checked}
              activateUrl={activateUrl}
              deactivateUrl={deactivateUrl}
              requestParams={{ ids: [this.props.id] }}
              onResponse={(response) => this.props.onAudienceStateChange(response.data)}
            />
          </SwitcherWrapper>
          <NameWrapper>
            <NameWrapperElement>
              <NameLink href={editPath}>{name}</NameLink>
            </NameWrapperElement>
            <NameWrapperElement>
              <NamePopup
                name={name}
                audienceId={id}
                onAudienceStateChange={(data, id) => this.props.onAudienceStateChange(data, [id])}
              />
            </NameWrapperElement>
          </NameWrapper>
        </MainCellContent>
      </Cell>
    )
  }

  renderAdvertisementsCell() {
    const {
      advertisementsCount,
      advertisementsPath,
      rejectedAdsCount,
      newAdvertisementPath,
      imported
    } = this.props

    return (
      <Cell className="nowrap">
        {advertisementsCount > 0 ? (
          <div>
            <a href={advertisementsPath} className="offable">
              <span>
                {this.tableTranslations('advertisements_count', {
                  smart_count: advertisementsCount
                })}
              </span>
            </a>
            {rejectedAdsCount > 0 && (
              <RejectedCounterWrapper>
                <Tooltip content={this.tableTranslations('rejected_count')}>
                  <RejectedCounter href={advertisementsPath} isMuted={!this.props.active}>
                    {rejectedAdsCount}
                  </RejectedCounter>
                </Tooltip>
              </RejectedCounterWrapper>
            )}
          </div>
        ) : (
          !imported && (
            <div>
              <a href={newAdvertisementPath} className="offable">
                <span>{this.tableTranslations('create_new')}</span>
              </a>
            </div>
          )
        )}
      </Cell>
    )
  }

  renderCommonCell(field: string, value: string) {
    return (
      <Cell alignRight className="nowrap" key={`audience_${this.props.id}_${field}`}>
        {this.attributeTranslations(value)}
      </Cell>
    )
  }

  renderUsersCell() {
    const { id, estimates } = this.props
    const users = _.compact(
      _.map(estimates, (estimate) => {
        return estimate.users
      })
    )
    return (
      <Cell alignRight className="nowrap" key={`audience_${id}_users`}>
        {users.length > 0 && _.round(_.sum(users) / users.length, 2)}
      </Cell>
    )
  }

  renderEstimatePriceCell(field: string) {
    const { id, estimates } = this.props
    return (
      <Cell alignRight className="nowrap" key={`audience_${id}_${field}`}>
        {this.props.providers_list.length === 1 &&
          !_.isEmpty(estimates) &&
          _.first(_.values(estimates))[field]}
      </Cell>
    )
  }

  renderAgeCell() {
    let age = ''
    if (this.props.min_age && this.props.max_age)
      age = `${this.props.min_age}-${this.props.max_age}`
    if (this.props.min_age && !this.props.max_age) age = `${this.props.min_age}+`
    return (
      <Cell alignRight className="nowrap" key={`audience_${this.props.id}_age`}>
        {age}
      </Cell>
    )
  }

  renderFbPlacementsCell() {
    const data: FbPlacementRenderData = renderData(
      this.props.fb_placements,
      this.props.audience_type,
      this.props.platform
    )
    return (
      <Cell alignRight className="nowrap" key={`audience_${this.props.id}_fbPlacements`}>
        {_.map(data, (item: FbPlacementPlatformRenderData) => {
          const translatedPlacements = _.map(
            item.positions,
            (position: FbPlacementPositionRenderData) => {
              return position.label
            }
          )
          return (
            <div key={item.platform}>{`${item.title}: ${_.join(translatedPlacements, ', ')}`}</div>
          )
        })}
      </Cell>
    )
  }

  renderLabelsCell(field: string, labels: Array<string>) {
    return (
      <Cell alignRight className="nowrap" key={`audience_${this.props.id}_${field}`}>
        {_.map(labels, (label, index: number) => {
          return <div key={`${this.props.id}_label_${index}`}>{label}</div>
        })}
      </Cell>
    )
  }
}
